/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_PrivacyInputs */

const en_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const zh_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Landing_Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_privacy = /** @type {((inputs?: Landing_Footer_PrivacyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_PrivacyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_privacy(inputs)
	return zh_landing_footer_privacy(inputs)
});
export { landing_footer_privacy as "landing.footer.privacy" }